const productSliderData = [
  {
    id: 1007,
    title: 'Summer Nights',
    price: 24.99,
    type: 'album',
    imgUrl: 'https://i.ibb.co/Qk70JDF/album-7.jpg',
    detail:
      "Twice's 2nd Special Album. There're version A, B and C. Randomly send version when purchasing one album. When purchasing 3 or more albums on an order, versions can be selected."
  },
  {
    id: 1002,
    title: 'More & More',
    price: 19.99,
    type: 'album',
    imgUrl: 'https://i.ibb.co/Lk5Mb6v/album-2.jpg',
    detail:
      "Twice's 9th Mini Album. There're version A, B and C. Randomly send version when purchasing one album. When purchasing 3 or more albums on an order, versions can be selected."
  },
  {
    id: 1009,
    title: 'Merry & Happy',
    price: 21.99,
    type: 'album',
    imgUrl: 'https://i.ibb.co/WpkwnXY/album-9.jpg',
    detail:
      "Twice's 1st Repackaged Album. There're version A and B. Randomly send version when purchasing one album. When purchasing 3 or more albums on an order, versions can be selected."
  },
  {
    id: 1005,
    title: 'The Year of YES',
    price: 26.99,
    type: 'album',
    imgUrl: 'https://i.ibb.co/DLm6tZf/album-5.jpg',
    detail:
      "Twice's 3rd Special Album. There're version A, B and C. Randomly send version when purchasing one album. When purchasing 3 or more albums on an order, versions can be selected."
  }
];

export default productSliderData;
